'use strict';

define(['view/components/tooltip', 'view/components/slider', 'utils/ui', 'utils/helpers'], function (Tooltip, Slider, UI, utils) {
    var VolumeTooltip = Tooltip.extend({
        'constructor': function constructor(_model, name) {
            this._model = _model;

            Tooltip.call(this, name);

            this.volumeSlider = new Slider('jw-slider-volume jw-volume-tip', 'vertical');
            this.addContent(this.volumeSlider.element());

            this.addVolumeValueTip();

            this.volumeSlider.on('update', function (evt) {
                this.trigger('update', evt);
            }, this);

            utils.removeClass(this.el, 'jw-hidden');

            new UI(this.el, { 'useHover': true, 'directSelect': true }).on('click', this.toggleValue, this).on('tap', this.toggleOpenState, this).on('over', this.openTooltip, this).on('out', this.closeTooltip, this);

            // this._model.on('change:volume', this.onVolume, this);
        },
        toggleValue: function toggleValue() {
            this.trigger('toggleValue');
        },
        addVolumeValueTip: function addVolumeValueTip() {
            var tipEl = document.createElement('div');

            tipEl.className = 'jw-volume-value-tip';
            utils.getElementsByClassName('jw-overlay', this.el)[0].appendChild(tipEl);
            this.valuetip = tipEl;
        }
    });

    return VolumeTooltip;
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/view/components/volumetooltip.js
 ** module id = 197
 ** module chunks = 0
 **/